<div class="table-wrapper">
  <!-- Header Area -->
  <div class="datatable-header">
    <!-- Use a title from config if provided; otherwise, show a default title -->
    <ng-container *ngIf="config?.title; else defaultTitle">
      {{ config.title }}
    </ng-container>
    <ng-template #defaultTitle>
      Data Table
    </ng-template>
  </div>

  <!-- Table Container with dynamic height -->
  <div class="datatable-container" [style.height.px]="tableHeight">
    <ngx-datatable
      class="bootstrap"
      [rows]="rows"
      [columns]="columns"
      [headerHeight]="headerHeight"
      [rowHeight]="rowHeight">
    </ngx-datatable>
  </div>

  <!-- Pagination Controls -->
  <div class="datatable-pagination">
    <!-- Page size selector -->
    <ion-item lines="none" class="page-size">
      <ion-label>Page Size</ion-label>
      <ion-select [(ngModel)]="limit" (ionChange)="onPageSizeChange($event)">
        <ion-select-option *ngFor="let size of pageSizes" [value]="size">
          {{ size }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <!-- Navigation Buttons -->
    <div class="pagination-buttons">
      <ion-button (click)="prevPage()" [disabled]="currentPage === 1">Prev</ion-button>
      <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <ion-button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</ion-button>
    </div>
  </div>
</div>
